<div class="lvi-content">
    <div class="avatar">
        {{ data.clef.substring(0, 3) }}
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="onSelect()">{{ data?.clef }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong>Valeur</strong>
                <span>{{ data?.valeur }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button (click)="deleteClef()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>
